import './ProfileRankings.css';

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { RankingPropsTypes } from '@models/Ranking';

import config from '@config';
import Button from '@views/Button';
import RankingCard from '@views/RankingCard';
import RankingCreate from '@views/RankingCreate';

const ProfileRankings = ({ rankings, onCreateClick }) => (
  <div className="profile-rankings">
    <div className="button-container">
      <Button onClick={onCreateClick} type="primary">
        Crear un nuevo torneo
      </Button>
      <RankingCreate />
    </div>
    {rankings && rankings.length ? (
      <div className="ranking-cards">
        <RankingCard.Header />
        {rankings.map((ranking) => (
          <RankingCard key={ranking._id} {...ranking} />
        ))}
      </div>
    ) : (
      <div className="empty-rankings">
        <img src={`${config.basePath}/img/copa-grey.svg`} alt="" />
        <p>
          Todavía no participás en ningún torneo. Creá uno e invitá a tus amigos
          para participar
        </p>
      </div>
    )}
  </div>
);

ProfileRankings.displayName = 'ProfileRankings';
ProfileRankings.propTypes = {
  rankings: PropTypes.arrayOf(PropTypes.shape(RankingPropsTypes)),
  onCreateClick: PropTypes.func,
};
ProfileRankings.defaultProps = {
  rankings: [],
  onCreateClick: noop,
};

export default ProfileRankings;
